var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgIconPlus = function SvgIconPlus(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-155.000000, -75.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0 C14.3284271,-1.52179594e-16 15,0.671572875 15,1.5 L15,12 L25.5,12 C26.3284271,12 27,12.6715729 27,13.5 C27,14.3284271 26.3284271,15 25.5,15 L15,15 L15,25.5 C15,26.3284271 14.3284271,27 13.5,27 C12.6715729,27 12,26.3284271 12,25.5 L12,15 L1.5,15 C0.671572875,15 1.01453063e-16,14.3284271 0,13.5 C-1.01453063e-16,12.6715729 0.671572875,12 1.5,12 L12,12 L12,1.5 C12,0.671572875 12.6715729,1.52179594e-16 13.5,0 Z",
    id: "Combined-Shape"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_plus.f0c50042.svg";
export { ForwardRef as ReactComponent };